import { OpusWrapper } from './opus-wrapper';
export class Encoder {
/**
 * @param {?} buffer
 * @param {?} format
 * @return {?}
 */
public static encode(buffer: AudioBuffer, format: String): Promise<Blob> {
    return new Promise<Blob>((resolve, reject) => {
      const /** @type {?} */ encodingWorker = new Worker('/tp-audio-editor/encoding-worker.js');

      encodingWorker.onmessage = e => {
        if (e.data.status === 'finished') {
          if (format === 'opus') {
            OpusWrapper.encode(e.data.blob).then(resolve, reject);
            encodingWorker.terminate();
          } else {
            encodingWorker.terminate();
            resolve(e.data.blob);
          }
        } else {
          encodingWorker.terminate();
          reject('An error occured while encoding');
        }
      };
      encodingWorker.onerror = e => {
        encodingWorker.terminate();
        reject(e);
      };

      encodingWorker.postMessage({
        format: format,
        buffer: Encoder.interleave(buffer),
        sampleRate: buffer.sampleRate
      });
    });
  }
/**
 * @param {?} buffer
 * @return {?}
 */
private static interleave(buffer: AudioBuffer): Float32Array[] {
    const /** @type {?} */ channels = buffer.numberOfChannels;
    const /** @type {?} */ out: Float32Array[] = [];
    for (let /** @type {?} */ ch = 0; ch < buffer.numberOfChannels; ++ch) {
      out[ch] = buffer.getChannelData(0);
    }
    return out;
  }

}
